import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader-afirme',
  templateUrl: './loader-afirme.component.html',
  styleUrls: ['./loader-afirme.component.scss']
})
export class LoaderAfirmeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
